
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlets",
      function () {
        return require("private-next-pages/outlets/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlets"])
      });
    }
  